<template>
  <wizard-base
    class="roof-renovation"
    :title="$t('WIZARD.ROOF_RENOVATION.TITLE')"
    :icon="slideIcon"
    :content-column-classes="['is-9', 'is-6-desktop']"
  >
    <div class="roof-renovation__fields">
      <hd-input
        v-model="lastRoofRenovationYear"
        name="lastRoofRenovationYear"
        type="number"
        :label="$t('GENERAL.LAST_RENOVATION')"
        :custom-rules="customRules"
        :required="isPriceDataChanged()"
      />
      <PriceContributionInput v-model="roofRenovationPrice" name="roofRenovation" />
    </div>
  </wizard-base>
</template>

<script>
import { toFinite as _toFinite, isNumber as _isNumber, inRange as _inRange } from 'lodash-es';

// Components
import { HdInput } from 'homeday-blocks';
import PriceContributionInput from '@/components/PriceContributionInput.vue';
import WizardBase from '@/layout/WizardBase.vue';
// Services
import { mapFeatures } from '@/services/feature';
import { mapPriceContributions } from '@/services/priceContribution';
// Icons
import { roofRepair as slideIcon } from 'homeday-assets/L';
import { MAXIMUM_YEAR, MINIMUM_YEAR } from '@/config/CONSTANTS';

export default {
  name: 'RoofRenovationSlide',
  components: {
    HdInput,
    PriceContributionInput,
    WizardBase,
  },
  data() {
    return {
      slideIcon,
    };
  },
  computed: {
    deal() {
      return this.$store.state.wizard.currentDeal;
    },
    ...mapFeatures(['lastRoofRenovationYear']),
    ...mapPriceContributions(['roofRenovation']),
    customRules() {
      return [
        {
          validate: (value) => {
            if (!_isNumber(Number(value))) return false;
            return _inRange(_toFinite(value), MINIMUM_YEAR, MAXIMUM_YEAR);
          },
          errorMessage: this.$t('FIELD_VALIDATIONS.INCORRECT_CONSTRUCTION_YEAR'),
        },
      ];
    },
  },
  methods: {
    isPriceDataChanged() {
      return this.roofRenovationPrice > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.roof-renovation {
  &__fields {
    display: grid;

    @include for('tablet') {
      grid-template-columns: 1fr 1.5fr;
      grid-column-gap: $sp-m;
    }
  }
}
</style>
